export default "__VITE_ASSET__84c81cc0__"